import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const TeamCard = ({
  name,
  role,
  designation,
  image,
  linkedin,
  profileLink,
}) => {
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      animate="rest"
      className="
        relative overflow-hidden
        rounded-2xl
        bg-white dark:bg-[#020617]
        border border-gray-200 dark:border-gray-800
        p-6
        shadow-sm
        hover:shadow-2xl
        transition-all duration-300
      "
    >
      {/* Gradient Hover Layer */}
      <motion.div
        variants={{
          rest: { opacity: 0, scale: 1.05 },
          hover: { opacity: 1, scale: 1 },
        }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        className="
          absolute inset-0 z-0
          bg-gradient-to-br
          from-[#2f8f52]
          via-[#3BAA5D]
          to-[#7AE0A1]
        "
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center">
        {/* Avatar */}
        <motion.div
          variants={{
            rest: { y: 0 },
            hover: { y: -4 },
          }}
          transition={{ duration: 0.3 }}
          className="
            relative
            h-28 w-28
            rounded-full
            overflow-hidden
            bg-gray-100 dark:bg-gray-800
            ring-4 ring-white/80 dark:ring-gray-900
            shadow-md border dark:border-white
          " 
        >
          {image ? (
            <img
              src={image}
              alt={name}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-2xl font-semibold text-gray-500">
              {name?.charAt(0)}
            </div>
          )}
        </motion.div>

        {/* Name */}
        <motion.h3
          variants={{
            rest: { color: "#111827" },
            hover: { color: "#ffffff" },
          }}
          className="mt-5 text-lg font-semibold dark:text-white"
        >
          {name}
        </motion.h3>

        {/* Role */}
        <motion.p
          variants={{
            rest: { color: "#3BAA5D" },
            hover: { color: "#ECFDF5" },
          }}
          className="mt-1 text-sm text-base"
        >
          {role}
        </motion.p>

        {/* Optional Designation */}
        {/* {designation && (
          <motion.p
            variants={{
              rest: { color: "#6B7280" },
              hover: { color: "#D1FAE5" },
            }}
            className="mt-1 text-xs"
          >
            {designation}
          </motion.p>
        )} */}

        {/* Divider */}
        <motion.span
          variants={{
            rest: { width: 24, opacity: 0.3 },
            hover: { width: 40, opacity: 0.7 },
          }}
          transition={{ duration: 0.3 }}
          className="mt-4 h-px bg-white dark:bg-dark"
        />

        {/* Actions */}
        <motion.div
          variants={{
            rest: { opacity: 0, y: 8 },
            hover: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="mt-4 flex gap-6"
        >
          {linkedin && (
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="
                text-sm font-medium text-white
                hover:underline underline-offset-4
              "
            >
              LinkedIn
            </a>
          )}

          {profileLink && (
            <Link
              to={profileLink}
              className="
                text-sm font-medium text-white
                hover:underline underline-offset-4
              "
            >
              Profile
            </Link>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TeamCard;
